"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = void 0;
exports.palette = {
    blue: {
        primary: '#1E6CF8',
        tint: '#EAF2FF',
        misc: '#5890F9'
    },
    red: {
        primary: '#D52C07',
        tint: '#FFF0EC',
        misc: '#F9603E',
    },
    green: {
        primary: '#007A5C',
        tint: '#EBF7F1',
        misc: '#00A87E',
        dark: '#003E2F'
    },
    purple: {
        primary: '#5423F6',
        tint: '#F7F5FF',
        misc: '#825EF7',
        dark: '#1F0087',
    },
    yellow: {
        primary: '#F5A623',
        tint: '#FFFDEF'
    },
    greyscale: {
        black: '#000000',
        darkest: '#444444',
        darker: '#666666',
        dark: '#888888',
        medium: '#C1C1C1',
        light: '#EAEAEA',
        lighter: '#F7F7F7',
        lightest: '#F7F7F7',
        white: '#FFFFFF'
    }
};
const paletteV5 = {
    purple: {
        primary: '#7E6EFA',
        purple2: '#A499F3',
    },
    pink: {
        primary: '#FC43F8',
    },
    green: {
        primary: '#56C9B4',
    },
    greyscale: {
        black: '#000000',
        gray1: '#333333',
        gray2: '#4F4F4F',
        gray3: '#888888',
        gray4: '#BDBDBD',
        gray5: '#E0E0E0',
        gray6: '#F2F2F2',
        white: '#FFFFFF'
    }
};
const withDefault = (swatch, k) => (Object.assign(Object.assign({}, swatch), { default: swatch[k] }));
const colours = {
    primary: withDefault(exports.palette.blue, 'primary'),
    error: withDefault(exports.palette.red, 'primary'),
    success: withDefault(exports.palette.green, 'primary'),
    neutral: exports.palette.greyscale,
    text: withDefault(exports.palette.greyscale, 'black'),
    background: {
        default: exports.palette.greyscale.lighter,
        lighter: exports.palette.greyscale.white,
        green: '#CCE4DE'
    },
    delimiter: {
        default: exports.palette.greyscale.light,
        dark: exports.palette.greyscale.medium
    },
    highlight: {
        default: exports.palette.yellow.primary
    },
    shadow: {
        default: '#0000000f'
    },
    tip: {
        default: '#4D22EC',
        tint: '#F5F2FF'
    },
};
const BASE_FONT = '\'Roboto\', Arial, sans-serif';
const typography = {
    fonts: {
        base: BASE_FONT,
        icons: 'TravelNest'
    },
    /* Section heading */
    a1: {
        fontFamily: BASE_FONT,
        fontWeight: 500,
        fontSize: '1.5rem',
        lineHeight: '1.875rem',
        color: colours.neutral.darkest,
    },
    /* Section sub-heading */
    a2: {
        fontFamily: BASE_FONT,
        fontWeight: 500,
        fontSize: '1.125rem',
        lineHeight: '1.375rem',
        color: colours.neutral.darkest,
    },
    /* Section sub-sub-heading */
    a3: {
        fontFamily: BASE_FONT,
        fontWeight: 500,
        fontSize: '1rem',
        lineHeight: '1.25rem',
        color: colours.neutral.darkest,
    },
    /* Paragraph */
    b1: {
        fontFamily: BASE_FONT,
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: '1.25rem',
        color: colours.neutral.darker,
    },
    /* Input label */
    c1: {
        fontFamily: BASE_FONT,
        fontWeight: 500,
        fontSize: '1.125rem',
        lineHeight: '1.375rem',
        color: colours.neutral.darkest,
    },
    /* Support text label */
    c2: {
        fontFamily: BASE_FONT,
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: '1.25rem',
        color: colours.neutral.dark,
    },
    /* TextField input */
    c3: {
        fontFamily: BASE_FONT,
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: '1.25rem',
        color: colours.neutral.darker,
    },
    /* Featured link text */
    d1: {
        fontFamily: BASE_FONT,
        fontWeight: 500,
        fontSize: '0.8125rem',
        lineHeight: '0.9375rem',
        color: colours.neutral.darker,
    },
    /* Featured foot-note */
    d2: {
        fontFamily: BASE_FONT,
        fontWeight: 400,
        fontSize: '0.625rem',
        lineHeight: '0.8125rem',
        color: colours.neutral.darker,
    },
    // Special cases, not to be used generally
    button: {
        fontFamily: BASE_FONT,
        fontWeight: 500,
        fontSize: '1rem',
    },
    number: {
        fontFamily: BASE_FONT,
        fontWeight: 900,
        fontSize: '3.75rem',
        color: colours.neutral.darkest,
    }
};
const typographyV5 = {
    fonts: {
        base: BASE_FONT,
        icons: 'TravelNest'
    },
    h1: {
        fontFamily: BASE_FONT,
        fontWeight: 500,
        fontSize: '26px',
        lineHeight: '32px',
        color: paletteV5.greyscale.gray1,
    },
    h2: {
        fontFamily: BASE_FONT,
        fontWeight: 500,
        fontSize: '20px',
        lineHeight: '24px',
        color: paletteV5.greyscale.gray1,
    },
    h3: {
        fontFamily: BASE_FONT,
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '20px',
        color: paletteV5.greyscale.gray1,
    },
    p: {
        fontFamily: BASE_FONT,
        fontWeight: 400,
        fontSize: '15px',
        lineHeight: '19px',
        color: paletteV5.greyscale.gray2,
    },
    pMed: {
        fontFamily: BASE_FONT,
        fontWeight: 500,
        fontSize: '15px',
        lineHeight: '19px',
        color: paletteV5.greyscale.gray2,
    },
    micro: {
        fontFamily: BASE_FONT,
        fontWeight: 500,
        fontSize: '13px',
        color: paletteV5.greyscale.gray3,
    },
};
const layout = {
    container: {
        maxWidth: '1200px'
    },
    radius: {
        default: '10px',
        squared: '5px'
    },
    spacing: {
        smallest: '5px',
        smaller: '10px',
        small: '15px',
        standard: '20px',
        large: '30px',
        xLarge: '40px'
    },
};
const motion = {
    transition: {
        default: '0.2s'
    }
};
exports.default = {
    palette: exports.palette,
    paletteV5,
    colours,
    layout,
    motion,
    typography,
    typographyV5,
};
//# sourceMappingURL=index.js.map